"use client";

import { ArrowRight, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Reach() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const map = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const offices = [];
  return <section data-section-id="15780" id="global-reach" className="relative py-24 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="mx-auto max-w-[1280px] px-6 md:px-8 lg:px-12">
        {}
        <div ref={header.ref} className={`text-center max-w-3xl mx-auto transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="font-default text-xs uppercase tracking-[0.15em] font-bold mb-6 text-primary">
            Global Presence
          </p>
          <h2 className="font-serif font-semibold text-[clamp(2rem,4vw,3rem)] leading-[1.2] tracking-[-0.01em] text-foreground">
            Engineering safety{" "}
            <span className="relative inline-block italic">
              across
              <span className={`absolute left-0 -bottom-1 h-px transition-all duration-[480ms] ease-out bg-primary ${header.isVisible ? "w-full" : "w-0"}`} style={{
              transitionDelay: "600ms"
            }} />
            </span>{" "}
            key industrial hubs.
          </h2>
          <p className="mt-6 font-default text-lg leading-[1.6] text-muted-foreground">
            Strategic fire protection and risk management services deployed where industrial complexity meets critical safety requirements.
          </p>
        </div>

        {}
        <div ref={grid.ref} className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {offices.map((office, i) => <div data-index={i} key={office.city} className={`group relative rounded-lg border border-secondary p-8 transition-all duration-[620ms] ease-out bg-card ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: `${i * 80}ms`
        }}>
              <h3 className="font-default text-xl font-semibold text-foreground tracking-normal">
                {office.city}
              </h3>

              <div className="mt-5 space-y-1 font-default text-sm leading-[1.5] text-muted-foreground">
                <p>{office.addressLine1}</p>
                <p>{office.addressLine2}</p>
                <p>{office.addressLine3}</p>
              </div>

              <div className="my-7 h-px w-full bg-secondary" />

              <div className="flex items-center gap-2 font-mono text-xs tracking-[0.01em] text-foreground">
                <Phone className="size-3.5" strokeWidth={1.5} />
                <span>{office.phone}</span>
              </div>

              <Link to="/ContactPage" className="mt-6 inline-flex items-center gap-2 font-default text-sm font-medium text-primary group/link">
                <span className="relative">
                  View location
                  <span className="absolute left-0 -bottom-0.5 w-full h-px transition-colors duration-220 bg-secondary" />
                  <span className="absolute left-0 -bottom-0.5 w-0 h-px transition-all duration-220 group-hover/link:w-full bg-primary" />
                </span>
                <ArrowRight className="size-4 transition-transform duration-220 group-hover/link:translate-x-1" strokeWidth={1.5} />
              </Link>
            </div>)}
        </div>

        {}
        
      </div>
    </section>;
}